import type { CSSProperties, FC, ReactNode } from 'react';
import { Badge } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface NotificationBadgeProps {
    active?: boolean;
    children: ReactNode;
    color?: string;
    offset?: [number, number];
    style?: CSSProperties;
}

const NotificationBadge: FC<NotificationBadgeProps> = ({
    active = false,
    children,
    color,
    offset = [-11, 11],
    style,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <Badge
            dot
            color={color ?? token.colorPrimary}
            offset={offset}
            style={{
                boxShadow: 'none',
                display: active ? undefined : 'none',
                ...style,
            }}
        >
            {children}
        </Badge>
    );
};

export default NotificationBadge;
